// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ActiveAiAssistantConfigurationQueryVariables = Types.Exact<{
  usage: Types.AiAssistantUsage;
}>;

export type ActiveAiAssistantConfigurationQuery = { __typename?: 'Query' } & {
  aiAssistantEnabled: { __typename?: 'AIAssistantEnabled' } & Pick<Types.AiAssistantEnabled, 'enabled'>;
  activeAIAssistantConfiguration: Types.Maybe<
    { __typename?: 'AIAssistantConfigurationSummaryType' } & Pick<
      Types.AiAssistantConfigurationSummaryType,
      'id' | 'name' | 'modelId' | 'description'
    >
  >;
};

export const ActiveAiAssistantConfigurationDocument = /*#__PURE__*/ gql`
    query ActiveAIAssistantConfiguration($usage: AIAssistantUsage!) {
  aiAssistantEnabled(usage: $usage) {
    enabled
  }
  activeAIAssistantConfiguration(usage: $usage) {
    id
    name
    modelId
    description
  }
}
    `;

/**
 * __useActiveAiAssistantConfigurationQuery__
 *
 * To run a query within a React component, call `useActiveAiAssistantConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveAiAssistantConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveAiAssistantConfigurationQuery({
 *   variables: {
 *      usage: // value for 'usage'
 *   },
 * });
 */
export function useActiveAiAssistantConfigurationQuery(
  baseOptions: Apollo.QueryHookOptions<
    ActiveAiAssistantConfigurationQuery,
    ActiveAiAssistantConfigurationQueryVariables
  > &
    ({ variables: ActiveAiAssistantConfigurationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ActiveAiAssistantConfigurationQuery, ActiveAiAssistantConfigurationQueryVariables>(
    ActiveAiAssistantConfigurationDocument,
    options,
  );
}
export function useActiveAiAssistantConfigurationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActiveAiAssistantConfigurationQuery,
    ActiveAiAssistantConfigurationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ActiveAiAssistantConfigurationQuery, ActiveAiAssistantConfigurationQueryVariables>(
    ActiveAiAssistantConfigurationDocument,
    options,
  );
}
// @ts-expect-error
export function useActiveAiAssistantConfigurationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ActiveAiAssistantConfigurationQuery,
    ActiveAiAssistantConfigurationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ActiveAiAssistantConfigurationQuery, ActiveAiAssistantConfigurationQueryVariables>;
export function useActiveAiAssistantConfigurationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ActiveAiAssistantConfigurationQuery,
        ActiveAiAssistantConfigurationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ActiveAiAssistantConfigurationQuery | undefined,
  ActiveAiAssistantConfigurationQueryVariables
>;
export function useActiveAiAssistantConfigurationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ActiveAiAssistantConfigurationQuery,
        ActiveAiAssistantConfigurationQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ActiveAiAssistantConfigurationQuery, ActiveAiAssistantConfigurationQueryVariables>(
    ActiveAiAssistantConfigurationDocument,
    options,
  );
}
export type ActiveAiAssistantConfigurationQueryHookResult = ReturnType<typeof useActiveAiAssistantConfigurationQuery>;
export type ActiveAiAssistantConfigurationLazyQueryHookResult = ReturnType<
  typeof useActiveAiAssistantConfigurationLazyQuery
>;
export type ActiveAiAssistantConfigurationSuspenseQueryHookResult = ReturnType<
  typeof useActiveAiAssistantConfigurationSuspenseQuery
>;
